interface PageHeaderProps {
  title: string;
  image?: string;
}

const PageHeader = ({ title, image = "/images/banners/a1.jpg" }: PageHeaderProps) => {
  return (
    <div
      className="page-banner-area mb-0 text-center position-relative z-1"
      style={{
        backgroundImage: `url(${image})`,
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        marginTop: "130px",
        paddingTop: "130px",
        paddingBottom: "195px",
      }}
    >
      <div>
        <h1 className=" fs-1 heading text-uppercase" data-cue="slideInUp">
          {title}
        </h1>
      </div>
    </div>
  );
};

export default PageHeader;
